import { PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { motion } from 'motion/react';
import { theme } from '@frontend/theme';

export const TimeTooltip = ({ children }: PropsWithChildren) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0 }}
      css={containerStyle}
    >
      {children}
    </motion.div>
  );
};

const containerStyle = css({
  pointerEvents: 'none',
  userSelect: 'none',
  borderRadius: theme.borderRadius.medium,
  background: theme.colors.black,
  color: theme.colors.white,
  padding: theme.spacing(1.5),
  whiteSpace: 'nowrap',
  maxWidth: 200,
  overflow: 'hidden',
});
